<template>
  <SelectFieldWithLoader
    v-if="brand"
    v-bind="$attrs"
    :options="categoriesOptions"
    search
    custom
  />
</template>

<script setup>
import { computed, markRaw } from 'vue'
import { useBrand } from '@/composables/useProfile'
import SelectFieldWithLoader from '@/components/SelectFieldWithLoader.vue'
import useTranslate from '@/composables/useTranslate'

defineOptions({
  compatConfig: {
    MODE: 3,
    INSTANCE_LISTENERS: false,
    INSTANCE_ATTRS_CLASS_STYLE: false,
  },
  inheritAttrs: false,
})

const { translate, translationsLoaded } = useTranslate()

const brand = useBrand()

const categoriesOptions = computed(() => {
  const loaded = translationsLoaded.value
  const options = brand.value.categories.map((category) => markRaw({
    value: category.name,
    label: category.name,
  }))
  options.unshift(markRaw({
    value: '',
    label: loaded ? translate('pb2.profilePropertiesView.noProfileCategoryOption') : 'None',
  }))
  return markRaw(options)
})
</script>
